var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 1a2 2 0 0 0-2 2v1H3a1 1 0 0 0 0 2h1v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6h1a1 1 0 1 0 0-2h-5V3a2 2 0 0 0-2-2zm4 3h-4V3h4zm-4 5a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1m3 1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0z",
  clipRule: "evenodd"
})));
export { SvgDelete as ReactComponent };